<template>
  <Authenticated>
    <div class="settings">
      <h1>Settings</h1>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "./_layouts/Authenticated.vue";
export default {
  name: "Settings",
  components: {
    Authenticated,
  },
  data() {
    return {
      // Add your data properties here
    };
  },
  computed: {
    // Add your computed properties here
  },
  methods: {
    // Add your methods here
  },
  mounted() {
    // Add your mounted logic here
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

</style>
